<template>
  <div class="about-tab-wrap pa-6">
    <v-row>
      <v-col :md="hasFiles ? 7 : 12" cols="12" sm="12">
        <div v-if="item.advantages" class="about-section mb-4">
          <div class="about-section__label">
            <v-icon small color="amber darken-2" class="mr-1">mdi-star-outline</v-icon>
            Vantagens
          </div>
          <div class="about-section__body" v-html="item.advantages"></div>
        </div>

        <div v-if="item.asus.description" class="about-section mb-4">
          <div class="about-section__label">
            <v-icon small color="primary" class="mr-1">mdi-text-box-outline</v-icon>
            Descrição do Formato
          </div>
          <div class="about-section__body" v-html="item.asus.description"></div>
        </div>

        <div v-if="item.description" class="about-section">
          <div class="about-section__label">
            <v-icon small color="blue-grey" class="mr-1">mdi-domain</v-icon>
            Descrição do Veículo
          </div>
          <div class="about-section__body" v-html="item.description"></div>
        </div>
      </v-col>

      <v-col md="5" cols="12" sm="12" v-if="hasFiles">
        <div class="about-section">
          <div class="about-section__label">
            <v-icon small color="blue-grey" class="mr-1">mdi-image-multiple-outline</v-icon>
            Galeria
          </div>
          <div class="about-gallery mt-3">
            <v-img
              v-for="(file, i) in item.asus.files"
              :src="file.thumb_128.url"
              class="about-gallery__img"
              :class="item.asus.files.length > 1 ? 'about-gallery__img--half' : 'about-gallery__img--full'"
              cover
              :key="i"
              @click="show(i)"
            ></v-img>
          </div>
        </div>
      </v-col>
    </v-row>

    <vue-easy-lightbox
      escDisabled
      :visible="visible"
      :imgs="items"
      :index="index"
      @hide="handleHide"
    ></vue-easy-lightbox>
  </div>
</template>
<script>
import VueEasyLightbox from "vue-easy-lightbox";
export default {
    name: "AboutTab",
  data() {
    return {
      index: null,
      visible: false,
    };
  },
  components: {
      VueEasyLightbox,
    },
  props: {
    item: Object,
    
  },
  computed: {
    hasFiles() {
      return this.item.asus.files && this.item.asus.files.length > 0;
    },
    items() {
      return this.item.asus.files.map((file) => {
        return file.original.url;
      });
    },
    isMobileClasses(){
      if(this.$root.isMobile){
        return "margin-bottom: 10px;"
      }
      else{
        return ""
      }
    }
  },
  methods: {
    show(i) {
      this.index = i;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
  },
};
</script>
<style lang="scss">
.about-tab-wrap {
  min-height: 300px;
}

.about-section {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e8eaf0;
  overflow: hidden;

  &__label {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    background: #f4f6f9;
    border-bottom: 1px solid #e8eaf0;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .05em;
    text-transform: uppercase;
    color: #546e7a;
  }

  &__body {
    padding: 14px 16px;
    font-size: 14px;
    line-height: 1.65;
    color: #37474f;
  }

  &--empty {
    display: none;
  }
}

.about-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;

  &__img {
    border-radius: 6px;
    cursor: pointer;
    transition: opacity .2s, transform .2s;

    &:hover {
      opacity: .85;
      transform: scale(1.01);
    }

    &--full {
      width: 100%;
      max-height: 260px;
    }

    &--half {
      width: calc(50% - 3px);
      aspect-ratio: 1;
    }
  }
}

.toolbar-btn__rotate {
  display: none !important;
}
</style>